'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _customers = require('redux/modules/customers');

var _kunaUtils = require('../../utils/kunaUtils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Customer = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user,
    loadedCustomers: state.customers,
    camerasState: state.cameras
    // zendesk: state.customers.zendesk,
  };
}, { loadCustomer: _customers.loadIfNeeded }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Customer, _Component);

  function Customer(props) {
    (0, _classCallCheck3.default)(this, Customer);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Customer.__proto__ || (0, _getPrototypeOf2.default)(Customer)).call(this, props));

    _this.state = {
      // scriptLoading: true,
      // customerName: null,
    };
    _this.componentWillUpdate = _this.componentWillUpdate.bind(_this);
    _this.componentDidMount = _this.componentDidMount.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(Customer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // Make the loadCustomer cached so calling it constantly has no perf impact
      this.props.loadCustomer(this.props.email);
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate() {
      // Make the loadCustomer cached so calling it constantly has no perf impact
      this.props.loadCustomer(this.props.email);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          loadedCustomers = _props.loadedCustomers,
          camerasState = _props.camerasState,
          email = _props.email,
          zdTicketUrl = _props.zdTicketUrl,
          zdTicketId = _props.zdTicketId,
          ticketAgentEmail = _props.ticketAgentEmail,
          children = _props.children,
          rest = (0, _objectWithoutProperties3.default)(_props, ['loadedCustomers', 'camerasState', 'email', 'zdTicketUrl', 'zdTicketId', 'ticketAgentEmail', 'children']);

      var lEmail = email.toLowerCase(); // All emails are taken as lowercase only
      if (!loadedCustomers[lEmail]) {
        return _react2.default.createElement('div', null);
      }
      var _loadedCustomers$lEma = loadedCustomers[lEmail],
          cameras = _loadedCustomers$lEma.cameras,
          zendesk = _loadedCustomers$lEma.zendesk,
          subscription = _loadedCustomers$lEma.subscription;

      // If the user in question has a subscription

      var hasUserSubcription = subscription.loaded && subscription.result.profile.has_subscription;

      var userPlan = hasUserSubcription ? subscription.result.subscription.plan_id : 'No Plan';

      var camSnWithPlan = cameras && cameras.find(function (cam) {
        return camerasState[cam].root.result.subscription;
      });
      var camWithPlan = camSnWithPlan ? camerasState[camSnWithPlan].root.result : null;
      var plan = camWithPlan ? camWithPlan.subscription.plan_id.replace(/_/g, ' ') : userPlan;

      var _getTrialInfo = (0, _kunaUtils.getTrialInfo)(loadedCustomers, lEmail),
          trial = _getTrialInfo.trial,
          onTrial = _getTrialInfo.onTrial,
          onCouponTrial = _getTrialInfo.onCouponTrial;

      var _getUserNotificationS = (0, _kunaUtils.getUserNotificationSetting)(loadedCustomers, lEmail),
          notificationsEnabled = _getUserNotificationS.notificationsEnabled,
          notificationsEnableAt = _getUserNotificationS.notificationsEnableAt,
          notificationsEnableRelative = _getUserNotificationS.notificationsEnableRelative;

      if (onTrial && camWithPlan === null) {
        plan = 'On Trial';
      }
      var timezone = cameras && cameras[0] && camerasState[cameras[0]] ? camerasState[cameras[0]].root.result.timezone : 'No camera';
      var openTickets = [];
      var closedTickets = [];
      var isBetaApp = false;
      if (zendesk && zendesk.result && zendesk.result.results) {
        var resultsExceptCurrent = zendesk.result.results.filter(function (ticket) {
          return ticket.id !== zdTicketId;
        });
        // eslint-disable-next-line no-restricted-syntax
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = (0, _getIterator3.default)(resultsExceptCurrent), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var ticket = _step.value;

            if (ticket.status === 'closed' || ticket.status === 'solved') {
              closedTickets.push(ticket);
            } else {
              openTickets.push(ticket);
            }
            // TODO
            // console.log('Ticket Info:  ' + JSON.stringify(ticket));
            if (ticket.recipient === 'beta@getkuna.com') {
              isBetaApp = true;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }

      var doesNotExistInDjango = subscription.error !== undefined;

      var isCostco = subscription.loaded && subscription.result.owns_costco_camera;

      var customerName = this.props.customerName ? this.props.customerName : '';

      var allForms = (0, _kunaUtils.getAllUserForms)(customerName, lEmail, cameras, zdTicketId, this.props.user.email, ticketAgentEmail);
      var formUrls = [{
        url: allForms.returnUrl,
        name: 'Return'
      }, {
        url: allForms.RMAUrl,
        name: 'Replacement'
      }, {
        url: allForms.stripeRefund,
        name: 'Plan Refund'
      }, {
        url: allForms.stripeCredits,
        name: 'Plan Credit'
      }, {
        url: allForms.phoneSupport,
        name: 'Phone Support'
      }, {
        url: allForms.qualityAudit,
        name: 'Quality Audit'
      }];

      var isAol = !!lEmail.match('aol.com');

      var userProps = (0, _extends3.default)({
        email: lEmail,
        customerName: customerName,
        plan: plan,
        onPlan: camWithPlan !== null || hasUserSubcription,
        trial: trial,
        onTrial: onTrial,
        onCouponTrial: onCouponTrial,
        timezone: timezone,
        cameras: cameras,
        openTickets: openTickets,
        closedTickets: closedTickets,
        zdTicketUrl: zdTicketUrl,
        zdTicketId: zdTicketId,
        isAol: isAol,
        isBetaApp: isBetaApp,
        doesNotExistInDjango: doesNotExistInDjango,
        formUrls: formUrls,
        notificationsEnabled: notificationsEnabled,
        notificationsEnableAt: notificationsEnableAt,
        notificationsEnableRelative: notificationsEnableRelative,
        isCostco: isCostco
      }, rest);
      return _react2.default.createElement(
        'div',
        null,
        _react.Children.map(children, function (child) {
          return _react2.default.cloneElement(child, userProps);
        })
      );
    }
  }]);
  return Customer;
}(_react.Component), _class2.propTypes = {
  user: _react.PropTypes.object,
  email: _react.PropTypes.string,
  customerName: _react.PropTypes.string,
  loadedCustomers: _react.PropTypes.object,
  loadedEmail: _react.PropTypes.object,
  camerasState: _react.PropTypes.object,
  children: _react.PropTypes.object,
  zendesk: _react.PropTypes.object,
  loadCustomer: _react.PropTypes.func.isRequired,
  ticketAgentEmail: _react.PropTypes.string,
  zdTicketId: _react.PropTypes.object,
  zdTicketUrl: _react.PropTypes.object
}, _temp)) || _class);
exports.default = Customer;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/CustomerWrapper/CustomerWrapper.js
 ** module id = 1393
 ** module chunks = 0
 **/